export function formatWorkItemNumber(num: number | null): string {
  if (num === null) return '—'
  return `# ${String(num).padStart(3, '0')}`
}
